import { render, staticRenderFns } from "./richtextweapp.vue?vue&type=template&id=5bae90a8&scoped=true"
import script from "./richtextweapp.vue?vue&type=script&lang=js"
export * from "./richtextweapp.vue?vue&type=script&lang=js"
import style0 from "./richtextweapp.vue?vue&type=style&index=0&id=5bae90a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bae90a8",
  null
  
)

component.options.__file = "richtextweapp.vue"
export default component.exports